@if (this.apiService.isSercom()) {
    <button kendoButton [svgIcon]="this.icon" (click)="this.isEdit = true" [title]="this.i18nLabel"></button>
    <kendo-dialog *ngIf="this.isEdit" title="Translate {{this.i18nLabel}}" width="1200px" (close)="this.isEdit = false">
        <div class="wgrid">
            <div>Key</div>
            @for (lang of this.translate.availableLanguages; track lang) {
                <div>{{lang}}</div>
            }
            <div>Buttons</div>
            @for (k of this.getKeys(); track k) {
                <div>{{k}}</div>
                @for (lang of this.translate.availableLanguages; track lang) {
                    <div>
                        <kendo-textbox style="width: 100%;" [value]="this.translate.getTranslationForLang(lang, k)" 
                        (valueChange)="this.translate.setTranslationForLang(lang, k, $event)"></kendo-textbox>
                    </div>
                }
                <div>
                    <button kendoButton (click)="this.searchOldKopTrans(k)">KopTrans</button>
                </div>
            }
        </div>
        <kendo-dialog-actions>
            <button kendoButton (click)="this.isEdit = false">Close</button>
        </kendo-dialog-actions>
    </kendo-dialog>        
}
